import React from 'react';
import { Button, Divider, Form } from 'semantic-ui-react';
import { change, Field, formValueSelector, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { find } from 'lodash';
import PhotoBoothModal from '../../../../../../../containers/PhotoBoothModal';
import { Tech3Input, Tech3Select } from '../../../../../../../components/FormElements';
import { required } from '../../../../../../../lib/FormValidators';

const occurrenceUpdateFormName = 'occurrenceUpdate';

const DataAcquisitionUpdateForm = props => {
  const type = props.type.charAt(0).toUpperCase() + props.type.slice(1);
  return (
    <PhotoBoothModal {...props}>
      <Form onSubmit={props.handleSubmit}>
        <h2>Edit {type}</h2>
        <Field
          label={`${type} Name`}
          name="name"
          type="text"
          placeholder={`${type} Name...`}
          component={Tech3Input}
          validate={[required]}
        />

        <Divider section />

        <Form.Group widths="equal">
          <Field
            label="Software"
            name="software_id"
            options={props.software}
            placeholder="Choose Software..."
            component={Tech3Select}
            upward
            validate={[required]}
            onChange={(event, newValue, previousValue) => {
              props.dispatch(change(occurrenceUpdateFormName, 'version_id', ''));
            }}
          />
          <Field
            label="Version"
            name="version_id"
            options={props.versions}
            placeholder="Choose Version..."
            component={Tech3Select}
            upward
            validate={[required]}
          />
        </Form.Group>

        <Button type="submit" disabled={props.submitting}>
          Update
        </Button>
      </Form>
    </PhotoBoothModal>
  );
};

DataAcquisitionUpdateForm.propTypes = {
  ...PhotoBoothModal.propTypes
};

DataAcquisitionUpdateForm.defaultProps = { ...PhotoBoothModal.defaultProps };

const editForm = reduxForm({
  form: occurrenceUpdateFormName,
  enableReinitialize: true
})(DataAcquisitionUpdateForm);

export default connect(state => ({
  software: state.projects.software.map((software, i) => {
    return {
      key: `software_${software.id}`,
      text: software.name,
      value: software.id
    };
  }),
  versions: (() => {
    const occurrenceEventFormSelector = formValueSelector(occurrenceUpdateFormName);
    const softwareVersions = find(state.projects.software, {
      id: parseInt(occurrenceEventFormSelector(state, 'software_id'), 10)
    });

    if (!softwareVersions) return null;
    return softwareVersions.equipment_software_versions.map((version, i) => {
      return {
        key: version.id,
        text: version.version_name,
        value: version.id
      };
    });
  })()
}))(editForm);



// WEBPACK FOOTER //
// ./src/scenes/projects/scenes/singleProject/components/experimentalDesign/modals/DataAcquisitionUpdateForm.js